"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionsChart = void 0;
const date_fns_1 = require("date-fns");
const helper_1 = require("./helper");
const sessionsChart = (dateRange, filters, granularity) => (0, helper_1.getChartQuery)(['Attribution.sessions'], dateRange, filters, undefined, rows => {
    return {
        lastRefreshTime: new Date(Math.max(...rows.flatMap(row => row
            .serialize()
            .loadResponse.results.map(result => new Date(result.lastRefreshTime).valueOf())))),
        seriesNames: () => [...rows[0].seriesNames()],
        chartPivot: () => rows[0].chartPivot().map(value => (Object.assign(Object.assign({}, value), { x: (0, date_fns_1.format)(new Date(value.x), 'yyyy-MM-dd'), xValues: value.xValues.map(x => (0, date_fns_1.format)(new Date(x), 'yyyy-MM-dd')) }))),
    };
}, undefined, granularity);
exports.sessionsChart = sessionsChart;
//# sourceMappingURL=sessions.js.map